<app-avatar
  [src]="src()"
  class="w-full h-full block rounded-[inherit] overflow-hidden relative"
>
  <div
    class="bg-gray-200 text-gray-400 absolute inset-0 flex items-center justify-center opacity-100 transition-opacity"
  >
    <mat-icon>image</mat-icon>
  </div>
</app-avatar>
<div
  class="absolute size-7 p-0.5 bg-gray-100 rounded-[inherit] bottom-0 -right-2 transition-colors"
  [ngClass]="{
    'text-gray-500 hover:text-gray-800 hover:cursor-pointer': !disabled(),
    'text-gray-300': disabled(),
  }"
  (click)="handleClick()"
  role="presentation"
>
  <mat-icon>add_circle</mat-icon>
</div>
